export enum PublicPaymentDisplay {
    None = 0,
    StatusOnly = 1,
    StatusAndPayLinks = 2
}
